<template>
  <div class="container">
    <div class="content">
      <template v-if="recordList.list?.length > 1">
        <div
          class="content_box"
          v-for="(item, index) in recordList.list"
          :key="index"
        >
          <div class="box_top">
            <div class="box_top_left">
              <img :src="item.requestingPartyPic" alt="" />
              <span>{{ item.requestingPartyName }}</span>
            </div>
            <div class="box_top_right">
              <p>{{ item.status ? "已接听" : "未接听" }}</p>
              <p>2024.05.25 15:20:20</p>
            </div>
          </div>
          <div class="box_content">
            <div class="box_content_box">
              <!-- <span>用户编号:{{item.requestingPartyId}}</span><span>所属工作室:{{item.}}</span> -->
            </div>
            <div class="box_content_box">
              <span>注册手机号:15878455414</span
              ><span>注册时间:2024.12.02 12:20:20</span>
            </div>
          </div>
          <div class="box_bottom" v-if="item.status == 0">
            <template v-if="item.message || item.messagePhone">
              <div>
                留言手机号： {{ item.messagePhone }} <span>联系客户</span>
              </div>
              <div v-if="item.message">留言：{{ item.message }}</div>
            </template>
            <template v-esle> 客户未留言 </template>
          </div>
          <div class="box_bottom" v-if="item.status == 1">
            <div>通话时长：{{ item.callDuration }}</div>
          </div>
        </div>
      </template>
      <template v-else>
        <van-empty description="暂无数据" />
      </template>
    </div>
  </div>
</template>
<script>
import {
  videoConsultationRecord,
  getStaffSchedule,
  getStudioInfo,
} from "@/api/home";
import { formatTime } from "@/hooks/function";
export default {
  name: "record",
  data() {
    return {
      scheduleInfo: {},
      studioId: "",
      recordList: {},
    };
  },
  components: {},
  async mounted() {
    await this.getUserInfo();
    await this.getVideoConsultationRecord();
    //await this.getStudioInfo();
  },
  methods: {
    async getUserInfo() {
      this.month = formatTime(new Date()).format("YYYY-MM");
      let scheduleParams = {
        date: formatTime(this.month).format("YYYY-MM-01"),
        staffNo: this.$store.state.assistantNo,
      };
      let { data: scheduleInfo } = await getStaffSchedule(scheduleParams);
      this.scheduleInfo = scheduleInfo;

      this.studioId = sessionStorage.getItem("studioId")
        ? sessionStorage.getItem("studioId")
        : scheduleInfo.channelId.split(",")[0];
    },
    getVideoConsultationRecord() {
      getStudioInfo({ id: this.studioId }).then((res) => {
        if (res.code == 0) {
          videoConsultationRecord({
            userId: 111, //this.$store.state.assistantNo
            workroomId: res.data.id, //
            page: 1,
          }).then((ress) => {
            if (ress.code == 0) {
              console.log(ress.data);
              this.recordList = ress.data;
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  //background: #fff;
  border-radius: 4px;
  padding: 8px;
}
.content {
  .content_box {
    background: #fff;
    box-sizing: border-box;
    padding: 16px;
    margin-bottom: 16px;
    border-radius: 8px;
    .box_top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .box_top_left {
        display: flex;
        align-items: center;
        img {
          margin-right: 8px;
          width: 30px;
          height: 30px;
          border-radius: 50%;
        }
      }
    }
    .box_content {
      border-bottom: 1px solid gray;
      margin-bottom: 12px;
      .box_content_box {
        display: flex;
        margin-bottom: 12px;
        span {
          display: block;
          width: 50%;
          text-align: left;
        }
      }
    }
    .box_bottom {
      div {
        margin-bottom: 10px;
      }
    }
  }
}
</style>